import React from "react";

function LinkedIn() {
  return (
    <svg
      id="Group_26072"
      data-name="Group 26072"
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
    >
      <circle
        id="Ellipse_2347"
        data-name="Ellipse 2347"
        cx="28"
        cy="28"
        r="28"
        fill="#007ab9"
      />
      <g
        id="Group_24480"
        data-name="Group 24480"
        transform="translate(11.999 11.177)"
      >
        <path
          id="Path_18419"
          data-name="Path 18419"
          d="M60.517,43.564V55.933H53.346V44.393c0-2.9-1.035-4.876-3.632-4.876a3.922,3.922,0,0,0-3.678,2.622,4.908,4.908,0,0,0-.237,1.748V55.932H38.628s.1-19.544,0-21.567H45.8v3.056c-.014.024-.035.048-.048.071H45.8v-.071a7.12,7.12,0,0,1,6.463-3.563c4.718,0,8.255,3.082,8.255,9.706Zm-29.391-19.6a3.737,3.737,0,1,0-.094,7.453h.047a3.738,3.738,0,1,0,.048-7.453ZM27.494,55.933h7.169V34.365H27.494Z"
          transform="translate(-27.068 -23.969)"
          fill="#f1f2f2"
        />
      </g>
    </svg>
  );
}

export default LinkedIn;
